import React, { memo } from "react";
import { AvGroup } from "availity-reactstrap-validation";
import { StyledLabel } from "@aureskonnect/react-ui";
import classnames from "classnames";
import { ValidationMessage } from "./ValidationMessage";
import MultiCustomSelect from "@components/Common/MultiCustomSelect";

export const CountrySelectField = memo(
    ({
        t,
        oneShop,
        countryData,
        setCountryData,
        countryList,
        setSelectCountry,
        selectCountry,
        allAssociatedCountryShop,
        setIsEdited,
    }: any) => (
        <AvGroup>
            <StyledLabel htmlFor="text" className="required__clz mt-3">
                {t("Country")}
            </StyledLabel>

            <MultiCustomSelect
                onDelete={() => setIsEdited(true)}
                blocked={oneShop}
                result={
                    oneShop
                        ? [...new Set([...countryData, ...countryList])]
                        : [
                              ...new Set([
                                  ...countryData,
                                  ...allAssociatedCountryShop,
                              ]),
                          ]
                }
                setResult={setCountryData}
                data={countryList.map((a: any) => a.label)}
                onChange={() => {
                    setIsEdited(true);
                    setSelectCountry(false);
                }}
                className={classnames("mdr_inp_FRcountry", {
                    invalid__clz: selectCountry,
                    "not-allowed-input-pm__clz": oneShop,
                })}
                placeholder={`${t("Select")}…`}
                value={t("Choose")}
                name="country"
                blockedList={oneShop ? countryList : allAssociatedCountryShop}
            />

            <ValidationMessage
                condition={selectCountry}
                text={t("Please select a country")}
            />
        </AvGroup>
    )
);
